import {
	AfterContentInit,
	Component,
	ContentChildren,
	Input,
	OnDestroy,
	OnInit,
	QueryList,
	ViewEncapsulation,
	signal,
} from '@angular/core';
import { MsTabComponent } from '../ms-tab/ms-tab.component';

interface Scope {
	loading: boolean;
}

@Component({
	selector: 'ms-tabs',
	templateUrl: './ms-tabs.component.html',
	styleUrls: ['./ms-tabs.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsTabsComponent implements OnInit, OnDestroy, AfterContentInit {
	@ContentChildren(MsTabComponent) tabs: QueryList<MsTabComponent>;

	scope: Scope = {
		loading: false,
	};

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	/**
	 * On After Content Init
	 */
	ngAfterContentInit() {
		// get all active tabs
		let activeTabs = this.tabs.filter((tab) => tab.active);

		// if there is no active tab set, activate the first
		if (activeTabs.length === 0) {
			this.selectTab(this.tabs.first);
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	selectTab(tab: any) {
		// deactivate all tabs
		this.tabs.toArray().forEach((tab) => (tab.active = false));

		// activate the tab the user has clicked on.
		tab.active = true;
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
